import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import { URL } from "../../api.jsx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const BranchAddEdit = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();

  const companyCodeParam = searchParams.get("companyCode");
  const branchCodeParam = searchParams.get("branchCode");

  const isEdit = Boolean(branchCodeParam);
  const userId = localStorage.getItem("userId");

  /* ===================== DROPDOWN ===================== */
  const [companyList, setCompanyList] = useState([]);

  /* ===================== FORM STATE ===================== */
  const [formData, setFormData] = useState({
    branchName: "",
    companyCode: "",
    address: "",
    branchManagerName: "",
    email: "",
    mobile: "",
    pincode: "",
    city: "",
    state: "",
    status: "ACTIVE",
    userName: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  /* ===================== FETCH COMPANIES ===================== */
  const fetchCompanies = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_LIST_BY_CODE);
      setCompanyList(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Company dropdown error", err);
    }
  };

  /* ===================== FETCH BRANCH (EDIT) ===================== */
  const fetchBranchDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `${URL.GET_ALL_BEANCHES}?companyCode=${companyCodeParam}&branchCode=${branchCodeParam}`
      );

      if (res.data?.data?.length > 0) {
        const b = res.data.data[0];
        setFormData({
          branchName: b.branchName || "",
          companyCode: b.companyCode || "",
          address: b.address || "",
          branchManagerName: b.branchManagerName || "",
          email: b.email || "",
          mobile: b.mobile || "",
          pincode: b.pincode || "",
          city: b.city || "",
          state: b.state || "",
          status: b.status || "ACTIVE",
          accountNumber: b.accountNumber || "",
          ifscCode: b.ifscCode || "",
          userName: "",
          password: "",
        });
      }
    } catch (err) {
      console.error("Fetch branch error", err);
    }
  };

  useEffect(() => {
    fetchCompanies();
    if (isEdit) fetchBranchDetails();
    if (!isEdit && companyCodeParam) {
      setFormData((prev) => ({ ...prev, companyCode: companyCodeParam }));
    }
  }, []);

  /* ===================== INPUT HANDLER ===================== */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /* ===================== SAVE ===================== */
 const toastShownRef = React.useRef(false);

const handleSave = async () => {
  if (loading) return; // 🔐 prevent double click

  try {
    setLoading(true);

    if (isEdit) {
      const res = await axiosInstance.post(
        `${URL.BRANCH_EDIT}?companyCode=${companyCodeParam}&branchCode=${branchCodeParam}`,
        {
          branchName: formData.branchName,
          branchManagerName: formData.branchManagerName,
          email: formData.email,
          mobile: formData.mobile,
          address: formData.address,
          city: formData.city,
          state: formData.state,
          pincode: formData.pincode,
          status: formData.status,
          accountNumber: formData.accountNumber,
          ifscCode: formData.ifscCode,
          updatedBy: Number(userId),
        }
      );

      if (res.data?.error) {
        toast.error(res.data.error);
        return;
      }

      if (!toastShownRef.current) {
        toast.success(res.data?.message || "Branch updated successfully");
        toastShownRef.current = true;
      }
    } else {
const res = await axiosInstance.post(URL.BRANCH_ADD, {
  branchName: formData.branchName,
  companyCode: Number(formData.companyCode),
  address: formData.address,
  branchManagerName: formData.branchManagerName,
  email: formData.email,
  mobile: formData.mobile,
  gstNumber: formData.gstNumber,
  pincode: formData.pincode,
  city: formData.city,
  accountNumber: formData.accountNumber,
  ifscCode: formData.ifscCode,
  state: formData.state,
  userName: formData.userName,
  password: formData.password,
  createdBy: Number(userId),
});

/* 🔹 CHECK API ERROR */
if (res.data?.error) {
  toast.error(res.data.error);
  return;
}

if (!toastShownRef.current) {
  toast.success(res.data?.message || "Branch added successfully");
  toastShownRef.current = true;
}
    }

    setTimeout(() => navigate(-1), 1200);
  } catch (err) {
    console.error(err);
const errorMessage =
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  "Something went wrong";

toast.error(errorMessage);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container">
      <h3 className="mb-3">{isEdit ? "Edit Agency" : "Add Agency"}</h3>

      <div className="card p-4">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Company</label>
            <select
              className="form-select"
              name="companyCode"
              value={formData.companyCode}
              onChange={handleChange}
              disabled={isEdit}
            >
              <option value="">Select Company</option>
              {companyList.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.value}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6">
            <label className="form-label">Agency Name</label>
            <input
              className="form-control"
              name="branchName"
              value={formData.branchName}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Agency Manager</label>
            <input
              className="form-control"
              name="branchManagerName"
              value={formData.branchManagerName}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Mobile</label>
            <input
              className="form-control"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
            />
          </div>

             <div className="col-md-6">
            <label className="form-label">Account Number</label>
            <input
              name="accountNumber"
              className="form-control"
              value={formData.accountNumber}
              onChange={handleChange}
            />
          </div>

           <div className="col-md-6">
            <label className="form-label">IFSC Code</label>
            <input
              name="ifscCode"
              className="form-control"
              value={formData.ifscCode}
              onChange={handleChange}
            />
          </div>

           <div className="col-md-6">
            <label className="form-label">GST Number</label>
            <input
              name="gstNumber"
              className="form-control"
              value={formData.gstNumber}
              onChange={handleChange}
              disabled={isEdit}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Pincode</label>
            <input
              className="form-control"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">City</label>
            <input
              className="form-control"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">State</label>
            <input
              className="form-control"
              name="state"
              value={formData.state}
              onChange={handleChange}
            />
          </div>

          {isEdit && (
            <div className="col-md-6">
              <label className="form-label">Status</label>
              <select
                className="form-select"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
              </select>
            </div>
          )}

          {!isEdit && (
            <>
              <div className="col-md-6">
                <label className="form-label">Username</label>
                <input
                  className="form-control"
                  name="userName"
                  value={formData.userName}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Password</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                  </button>
                </div>
              </div>
            </>
          )}

          <div className="col-md-12">
            <label className="form-label">Address</label>
            <textarea
              className="form-control"
              rows="2"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
          </div>

         <div className="mt-4 d-flex gap-2">
          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={loading}
          >
            {isEdit ? "Update Branch" : "Save Branch"}
          </button>

          <button
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
          
          </div>
        
         </div>
         <ToastContainer
  position="top-right"
  autoClose={3000}
  newestOnTop
  closeOnClick
  pauseOnHover
  draggable
/>

         </div>
         
    
  );
  
};

export default BranchAddEdit;